import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=1a9d2d2f&"
import script from "./UpdateAvatar.vue?vue&type=script&lang=ts&"
export * from "./UpdateAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports